<script>
import Layout from "@/pages/congdan/layout";
import Multiselect from "vue-multiselect";
import VueEasyLightbox from "vue-easy-lightbox";
import Carousel from 'vue-slick-carousel';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
/**
 * Crypto ICO-landing page
 */
export default {
  components: {Layout, VueEasyLightbox,VueSlickCarousel},
  data() {
    return {
      data: [],
      start: 2,
      // url: `${process.env.VUE_APP_API_URL}files/view`,
      totalRows: 1,
      numberOfElement: 1,
      perPage: 9,
      currentPage: 1,
      sortBy: "age",
      sortDesc: false,
      model:[],
      filterOn: [],
      pageOptions: [5,10,25,50,100],
      url: `${process.env.VUE_APP_API_URL}filesminio/view`,
      apiView: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      hoa:[],
      keyFile: 0,
      relink:[],
      indexImage: 0,
      visible: false,
      listPicture: [],
      ImagesShow: [],
      index: 0,
      slickOptions: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
      },
      settings: {
        "arrows": false,
        "dots": false,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 7,
        "slidesToScroll": 1,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 6,
              "slidesToScroll": 3,
              "infinite": true,
              "dots": false
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 6,
              "slidesToScroll": 4,
              "initialSlide": 4,
              "dots": false
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 5,
              "slidesToScroll": 3,
              "dots": false
            }
          }
        ]
      },
    };
  },
  computed: {

  },
  watch: {

  },
  created() {
    console.log("LOG CREATED LIEN HE ")
    window.addEventListener("scroll", this.windowScroll);
    this.getData();
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  mounted() {
    this.start = new Date(this.starttime).getTime();
    this.end = new Date(this.endtime).getTime();
    // Update the count down every 1 second
  },
  methods: {
    handleShowRegisterModal(){
      this.$store.dispatch("snackBarStore/showRegisterModal", !this.$store.state.snackBarStore.registerModal)
      console.log("abc")
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    /**
     * Window scroll method
     */
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
      ) {
        navbar.classList.add("nav-sticky");
      } else {
        navbar.classList.remove("nav-sticky");
      }
    },
    /**
     * Toggle menu
     */
    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    normalizer(node) {
      if (node.children == null || node.children == 'null') {
        delete node.children;
      }
    },
    async getData(){
      await this.$store.dispatch("senStore/getById", {
        "id": this.$route.params.id
      }).then((res) => {
        this.hoa = res.data;
        if(this.hoa.noiDung && this.hoa.noiDung != null) {
          this.hoa.noiDung = this.hoa.noiDung.replaceAll("https://localhost:5001/api/v1/filesminio/view" , this.url);
        }
        if(this.hoa.cayGiong && this.hoa.cayGiong != null) {
          this.hoa.cayGiong = this.hoa.cayGiong.replaceAll("https://localhost:5001/api/v1/filesminio/view" , this.url);
        }
        if(this.hoa.sauBenh && this.hoa.sauBenh != null) {
          this.hoa.sauBenh = this.hoa.sauBenh.replaceAll("https://localhost:5001/api/v1/filesminio/view" , this.url);
        }
        if(this.hoa.loaiSen.content && this.hoa.loaiSen.content != null) {
          this.hoa.loaiSen.content = this.hoa.loaiSen.content.replaceAll("https://localhost:5001/api/v1/filesminio/view" , this.url);
        }
        if(res.data.file && res.data.file != null){
          res.data.file.forEach((elements) => {
          this.listPicture.push(elements)
          this.ImagesShow.push(this.apiView + elements?.fileId)
            }
        )}
      })
    },
    HandleClickImage(index) {
      this.indexImage = index;
    },
    showImg(indexImage) {
      this.keyFile = indexImage;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    getId(id){
      this.relink.push(process.env.VUE_APP_API_URL + 'filesminio/view/' + id)
      this.showPreview();
    },
    showPreview() {
      const preview = this.$imagePreview({
        initIndex: 0,
        images:this.relink,
        isEnableBlurBackground: false,
        isEnableLoopToggle: true,
        initViewMode: "contain",
        containScale: 1,
        shirnkAndEnlargeDeltaRatio: 0.2,
        wheelScrollDeltaRatio: 0.2,
        isEnableImagePageIndicator: true,
        maskBackgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 4000,
        isEnableDownloadImage: true
      })
      this.relink=[]
    },

  },
};
</script>

<template>
  <Layout>
    <section class="section p-2 bg-white" id="about">
        <div class="row align-items-center">
          <div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12" style="margin-top: 70px;">
                            <div class="vueslick">
                              <div class="popup-gallery flex-wrap justify-content-center">
                                <div
                                    style="padding:5px; width: 100%;"
                                    @click="() => showImg(indexImage)"
                                >
                                  <img
                                      v-if="listPicture[indexImage]"
                                      class="card-img-carousel img-res"
                                      :src="apiView + listPicture[indexImage].fileId"
                                      height="300px"
                                      style="object-fit: cover;"
                                  >
                                </div>
                                <vue-easy-lightbox
                                    :visible="visible" :imgs="ImagesShow" :index="keyFile"
                                    @hide="handleHide">
                                </vue-easy-lightbox>
                              </div>
                              <div class="border carousel-img">
                                <VueSlickCarousel v-bind="settings">
                                  <div
                                      v-for="(src, index) in listPicture" :key="index"
                                      class=""
                                      style="height: 150px;"
                                  >
                                    <img
                                        class="card-img-carousel-sub"
                                        :src="apiView + src.fileId"
                                        @click="HandleClickImage(index)"
                                    >
                                  </div>
                                </VueSlickCarousel>
                              </div>
                            </div>

                            <div class="" style="position: relative;">
                              <div class="mb-2">
                                <h3 style="color: rgb(216 38 110);">
                                  <i class="bx bx-book"></i>
                                    Mô tả chi tiết
                                </h3>
                              </div>
                              <div class="chitiet">
                                <div class="item-name" style="font-size: 15px;">
                                  <span>Tên gọi:</span>
                                  <span style="font-weight: bold; margin-left: 10px;">{{ this.hoa.name }}</span>
                                </div>
                                <div class="item-name" style="font-size: 15px;">
                                  <span>Tên khoa học:</span>
                                  <span style="font-weight: bold; margin-left: 10px;">{{ this.hoa.engName }}</span>
                                </div>
                                <!-- <div class="item-name" style="font-size: 15px;">
                                  <span>Mô tả:</span>
                                  <span style="font-weight: bold; margin-left: 10px;">...</span>
                                </div> -->
                              </div>
                              <div class="mt-2 mb-2">
                                <h3 style="color: rgb(216 38 110);">
                                  <i class="bx bxs-tree"></i>
                                    Quá trình canh tác
                                </h3>
                              </div>
                              <div class="chitiet-content">
                                <div v-html="hoa.loaiSen.content"></div>
                              </div>
                              <!-- <div class="mt-4 mb-2">
                                <h3 style="color: rgb(216 38 110);">
                                  <i class="bx bx-bug-alt"></i>
                                    Sâu bệnh chính
                                </h3>
                              </div>
                              <div class="chitiet">
                                <div v-html="hoa.sauBenh"></div>
                              </div> -->
                              <img
                                    :src="apiView + hoa.qrCode?.fileId"
                                    class="rounded-0 qrcode"
                                >
                              <!-- <img src="@/assets/images/qrCode.jpg" alt="" width="100px" style="position: absolute;right: 10px; top: 10px;"> -->
                            </div>
                        </div>

                        <!-- <div class="col-md-12">
                          <div class="row mt-2">
                            <div class="col-md-6">
                              <div class="card-body card-box">
                                  <h4 style="padding: 20px;">Quá trình canh tác</h4>

                                  <div>
                                    <ul class="verti-timeline list-unstyled" style="padding-left: 28px; margin: 0 15px !important;">
                                      <li class="event-list" style="padding: 0px !important;">
                                        <div class="event-timeline-dot">
                                          <i class="bx bx-right-arrow-circle"></i>
                                        </div>
                                        <div class="d-flex">
                                          <div class="me-3">
                                            <i class="bx bxs-tree h2 text-primary"></i>
                                          </div>
                                          <div class="flex-grow-1">
                                            <div>
                                              <h5 class="font-size-14" style="color: #000;">GIÁ THỂ</h5>
                                              <p class="text-muted">
                                                {{ this.hoa.giaThe }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                      <li class="event-list" style="padding: 0px !important;">
                                        <div class="event-timeline-dot">
                                          <i class="bx bx-right-arrow-circle"></i>
                                        </div>
                                        <div class="d-flex">
                                          <div class="me-3">
                                            <i class="bx bx-copy-alt h2 text-primary"></i>
                                          </div>
                                          <div class="flex-grow-1">
                                            <div>
                                              <h5 class="font-size-14" style="color: #000;">TRỒNG CHẬU</h5>
                                              <p class="text-muted">
                                                {{ this.hoa.trongChau }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </li>

                                      <li class="event-list" style="padding: 0px !important;">
                                        <div class="event-timeline-dot">
                                          <i class="bx bx-right-arrow-circle"></i>
                                        </div>
                                        <div class="d-flex">
                                          <div class="me-3">
                                            <i class="bx bxs-color-fill h2 text-primary"></i>
                                          </div>
                                          <div class="flex-grow-1">
                                            <div>
                                              <h5 class="font-size-14" style="color: #000;">TƯỚI NƯỚC</h5>
                                              <p class="text-muted">
                                                {{ this.hoa.tuoiNuoc }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                      <li class="event-list" style="padding: 0px !important;">
                                        <div class="event-timeline-dot">
                                          <i class="bx bx-right-arrow-circle"></i>
                                        </div>
                                        <div class="d-flex">
                                          <div class="me-3">
                                            <i class="bx bx-shape-square h2 text-primary"></i>
                                          </div>
                                          <div class="flex-grow-1">
                                            <div>
                                              <h5 class="font-size-14" style="color: #000;">BÓN PHÂN</h5>
                                              <p class="text-muted">
                                                {{ this.hoa.bonPhan }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                      <li class="event-list" style="padding: 0px !important;">
                                        <div class="event-timeline-dot">
                                          <i class="bx bx-right-arrow-circle"></i>
                                        </div>
                                        <div class="d-flex">
                                          <div class="me-3">
                                            <i class="bx bx-cut h2 text-primary"></i>
                                          </div>
                                          <div class="flex-grow-1">
                                            <div>
                                              <h5 class="font-size-14" style="color: #000;">CẮT TỈA</h5>
                                              <p class="text-muted">
                                                {{ this.hoa.catTia }}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-3" v-if="!this.hoa.chamSoc">
                              <div class="card-body row" style="box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 17%) !important;">
                                <div class="col-md-12" style="height: 100%;">
                                  <h4 style="padding: 10px; color: rgb(216 38 110);">Quá trình chăm sóc của cây</h4>
                                </div>
                                <div class="col-md-6 mb-2" v-for="(item, index) in this.hoa.chamSoc" :key="index">
                                  <b-card no-body class="mb-2" style="box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 17%) !important;">
                                    <b-row no-gutters class="align-items-center card-intro">
                                      <b-col md="12" style="position: relative;">
                                          <div v-if="!item.file?.fileId">
                                            <div class="float-left">
                                              <img
                                                  alt="Không có ảnh"
                                                  class="w-100"
                                                  style="object-fit:contain; height: 175px; padding: 10px; border-top-right-radius: 5px !important; border-top-left-radius: 5px !important;"
                                              >
                                            </div>
                                          </div>
                                          <div v-else>
                                              <b-card-img
                                                  :src="apiView + item.file?.fileId"
                                                  class=""
                                                  style="object-fit:contain; height: 175px; border-top-right-radius: 5px !important; border-top-left-radius: 5px !important;"
                                              ></b-card-img>
                                          </div>
                                      </b-col>
                                      <b-col md="12" style="padding: 5px 25px;" class="title-category">
                                            <p style="text-align: center; margin-bottom: 0px;">
                                              <span style="font-weight: bold; color: #000;">{{ item.name }}</span>
                                            </p>
                                      </b-col>
                                    </b-row>
                                  </b-card>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- <div>
                          <Carousel :options="slickOptions">
                            <div class="items" v-for="(item, index) in this.hoa.files" :key="index">
                              <img :src="apiView + item.fileId" />
                            </div>
                          </Carousel>
                        </div> -->
                        <div class="col-md-12 mb-3">
                          <div class="title mt-4 mb-4">
                            <h2>
                                {{ this.hoa.name }}
                            </h2>
                          </div>
                          <div v-html="hoa.noiDung" class="noidung" style="font-size: 14px; text-align: justify;">
                          </div>
                        </div>
                      </div>

                      <div class="row d-flex align-items-baseline mb-3">
                        <div class="col-6 position-relative pt-4">
                          <a
                            @click="$router.go(-1)"
                            class="back"
                          >
                            <i class="bx bx-left-arrow-alt me-2 text-white"></i>
                            Quay lại
                          </a>
                        </div>
                        <!-- <div class="col-6 position-relative pt-4" style="font-size: 16px; text-align: right;">
                          <span style="font-weight: bold; color: #000;">Số lượt xem:</span>
                          <span style="margin-left: 10px;">{{ this.hoa.view }}</span>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  </Layout>
</template>
<style>

.chitiet-content p{
  margin-bottom: 0 !important;
}

.chitiet-content ul{
  margin-bottom: 0 !important;
}
</style>
